export var greylight100 = '#FFFFFF';
export var greylight200 = '#F2F2F3';
export var greylight300 = '#D7D9DB';
export var greylight400 = '#CACCCE';
export var greylight500 = '#BCC0C2';
export var greylight600 = '#AFB3B6';
export var greylight700 = '#A1A7AA';
export var greylight800 = '#949A9E';
export var greylight900 = '#868D92';
export var greylight1000 = '#798186';
export var greydark100 = '#6D7478';
export var greydark200 = '#61676B';
export var greydark300 = '#555A5E';
export var greydark400 = '#484D51';
export var greydark500 = '#3C4043';
export var greydark600 = '#303336';
export var greydark700 = '#242728';
export var greydark800 = '#181A1B';
export var greydark900 = '#0C0D0D';
export var greydark1000 = '#000000';
export var yellow100 = '#FFF1BF';
export var yellow200 = '#FFEC44';
export var yellow300 = '#987B12';
export var yellow400 = '#67510D';
export var yellow500 = '#45330A';
export var cyan100 = '#D1FFEF';
export var cyan200 = '#0CCACA';
export var cyan300 = '#108888';
export var cyan400 = '#055A5A';
export var cyan500 = '#023939';
export var blue100 = '#B5DFFB';
export var blue200 = '#2CA6FF';
export var blue300 = '#0F71C1';
export var blue400 = '#054C99';
export var blue500 = '#0A2A5A';
export var lavender50 = '#CFCEFD80';
export var lavender100 = '#CFCEFD';
export var lavender200 = '#A5AEFF';
export var lavender300 = '#665AF4';
export var lavender400 = '#493FB9';
export var lavender500 = '#201F60';
export var pink100 = '#FED8FE';
export var pink200 = '#E7B5FF';
export var pink300 = '#B530FF';
export var pink400 = '#7200AB';
export var pink500 = '#390C52';
export var orange100 = '#FBCFC4';
export var orange200 = '#FED8FE';
export var orange300 = '#DE4E31';
export var orange400 = '#A13413';
export var orange500 = '#602008';
export var green100 = '#B9FDC0';
export var green200 = '#8BDF94';
export var green300 = '#1C9242';
export var green400 = '#1B6232';
export var green500 = '#13391F';
export var red100 = '#FAD3D3';
export var red200 = '#FA6868';
export var red300 = '#DE3333';
export var red400 = '#871515';
export var red500 = '#581111';